import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck } = FiIcons;

const avatars = [
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=100&h=100",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100&h=100",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=100&h=100",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=100&h=100"
];

const SocialProof = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center gap-4 mb-8"
    >
      <div className="flex items-center gap-3 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full border border-slate-100 shadow-sm">
        <div className="flex -space-x-2">
          {avatars.map((url, i) => (
            <img 
              key={i} 
              src={url} 
              className="w-8 h-8 rounded-full border-2 border-white object-cover" 
              alt="User" 
            />
          ))}
          <div className="w-8 h-8 rounded-full border-2 border-white bg-brand-600 flex items-center justify-center text-[10px] font-bold text-white">
            1k+
          </div>
        </div>
        <p className="text-sm font-semibold text-slate-600">
          Trusted by 1,000+ users planning their EPF
        </p>
      </div>
      
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-emerald-50 text-emerald-700 text-xs font-bold uppercase tracking-wider">
        <span>🇲🇾</span> Built for Malaysian workforce
      </div>
    </motion.div>
  );
};

export default SocialProof;